import { ReactNode } from 'react'

import { CheckPickerItemType } from './CheckPicker.types'

export const checkPickerSearchBy = (
  keyword: string,
  _label: ReactNode,
  item: CheckPickerItemType,
): boolean => {
  if (keyword && keyword.length > 0) {
    const labelString = item.label && item.label.toString()
    const keywordString = keyword.trim().replace(/[^a-zA-Z0-9]/g, '')
    const pattern = new RegExp(`\\b${keywordString}`, 'gi')

    return Boolean(labelString && labelString.match(pattern))
  }

  return true
}
